import React, { useState } from "react";
import "./artistinresidency-section1/style.css";
import ReactHtmlParser from "react-html-parser";
import { IMAGE_BASE_URL } from "../../../services/api";
import { Link } from "react-router-dom";
import { formatDate } from "../../helper/formatDate";
import { LightBoxSimple } from "../lightboxsimple/LightBoxSimple";

export default function ArtistsInResidencyColumned(props) {
    const { t, appLanguage } = props;
    const currentArtist = props.profile || null;
    const [toggle, setToggle] = useState(false);
    const [sIndex, setSIndex] = useState(0);

    // Handler
    const lightBoxHandler = (state, sIndex) => {
        setToggle(state);
        setSIndex(sIndex);
    };

    return (
        <div>
            {
                currentArtist && (
                    <div className="homesection4__info-text">
                        {
                            props.profileNameClickable !== false ? (
                                <Link to={`/artistprofile/${currentArtist.id}`}>
                                    <p className="homesection4__text-line2 fs-5-5em">
                                        {currentArtist.name}
                                    </p>
                                </Link>
                            ) :
                                <p className="homesection4__text-line2 fs-5-5em">
                                    {currentArtist.name}
                                </p>
                        }

                        <p className="homesection4__text-line1">
                            {formatDate(currentArtist.dateStart)} - {formatDate(currentArtist.dateEnd)}
                        </p>
                    </div>
                )
            }
            <div className="artistInResidencySection1sub1__container">
                {currentArtist && (
                    <div className="artistInResidencySection1sub1__content flex row currentArtistSectionRow">
                        <div className="flexGrow paddedRightSm">
                            <div className="artistprofilesection2__artist-description fs-1-1em ">
                                <div className="ck-content">
                                    {
                                        appLanguage === 'en' && ReactHtmlParser(currentArtist?.en_description)
                                    }
                                    {
                                        appLanguage === 'no' && ReactHtmlParser(currentArtist?.no_description)
                                    }
                                </div>
                                {props.showWebsite && currentArtist.website && (
                                    <div style={{ marginTop: "20px" }}>
                                        <p className="artistprofilesection2__artist-link-title text-fabric-sans fs-1-6em lh-1-2em">
                                            {t("Visit Website")}:
                                        </p>
                                        <p className="artistprofilesection2__artist-link  text-fabric-sans fs-1-6em lh-1-2em">
                                            <a href={`${currentArtist.website}`} target="_blank">{currentArtist.website}hdeueuhuf</a>
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="currentArtistPictureContainer flexGrow paddedSm">
                            {currentArtist?.profileImg?.url && (
                                <img
                                    onClick={() => {
                                        lightBoxHandler(true, 0);
                                    }}
                                    src={`${IMAGE_BASE_URL}${currentArtist.profileImg.url}`} />
                            )}
                            {currentArtist?.imageCaption && <div>
                                <span className="artistprofilesection1__img-caption">
                                    {currentArtist?.imageCaption}
                                </span>
                            </div>}
                        </div>
                    </div>
                )}
            </div>
            <LightBoxSimple
                toggle={toggle}
                lightBoxHandler={lightBoxHandler}
                data={[
                    {
                        "id": 1,
                        "image": `${IMAGE_BASE_URL}${currentArtist?.profileImg?.url}`,
                        "title": "",
                        "description": ""
                    }
                ]}
                sIndex={sIndex}
                setSIndex={setSIndex}
            />
        </div>
    );
}
